module.exports = __webpack_public_path__ + "img/b2.cae7d842.png";